import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { currentRouteSelector } from 'shared/app/state/selectors/routes';

import { usePdpContext } from '../pdp-provider';

import messages from './messages';

const FullNutritionLink = () => {
  const { product } = usePdpContext();
  if (product?.error) {
    return null;
  }
  const { pathname } = useSelector(currentRouteSelector) || {};

  const isNutritionPage = Boolean(pathname?.includes('/nutrition'));
  return !isNutritionPage && pathname ? (
    <Link
      className="sb-button sb-button--default sb-button--white mt4"
      data-e2e="fullNutritionLink"
      to={`${pathname}/nutrition`}
    >
      <FormattedMessage {...messages.fullNutritionLink} />
    </Link>
  ) : null;
};

export default FullNutritionLink;
